document.addEventListener('click', async function (e) {
    const btnModalEditarCliente = e.target.closest('#btnModalEditarCliente');
    if (!btnModalEditarCliente) return;

    const idCliente   = btnModalEditarCliente.getAttribute("data-id");
    const formEditar  = document.querySelector("#formEditarCliente");
    const modalEditar = document.querySelector("#ModalEditarCliente");

    if (!formEditar || !idCliente || !modalEditar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para editar el cliente.", "alerta-roja");
        }
        return;
    }

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const url = `/api/configuracion/clientes/infoCliente?idCliente=${idCliente}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data   = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información del cliente.", "alerta-roja");
            }
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEditar.classList.add('modal--show');

        const inputId     = formEditar.querySelector('#idClienteEditar');
        const inputCodigo = formEditar.querySelector('#codigoSapEditarDisplay');
        const inputNombre = formEditar.querySelector('[name="nombreSap"]');
        const divShitch   = formEditar.querySelector('#divShitchCliente');

        if (inputId)     inputId.value     = data.idCliente || "";
        if (inputCodigo) inputCodigo.value = data.codigoSap || "";
        if (inputNombre) inputNombre.value = data.nombreSap || "";

        const checked     = Number(data.estado) === 1 ? 'checked' : '';
        const textoEstado = Number(data.estado) === 1 ? 'ACTIVO' : 'INACTIVO';

        divShitch.innerHTML = `
            <span class="labelInfo">Estado:</span>
            <label class="switchEstado">
                <input
                    id="estado"
                    type="checkbox"
                    name="estado"
                    value="${data.estado}"
                    ${checked}
                >
                <span class="sliderEstado"></span>
                <span class="textoEstado">${textoEstado}</span>
            </label>
        `;

    } catch (error) {
        console.error("Error al obtener información del cliente:", error);
        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información del cliente.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEditarCliente') {
        e.preventDefault();
        const formulario = e.target;
        const btnSubmit  = formulario.querySelector('#btnEditarCliente');
        const spinner    = formulario.querySelector('#spinner');
        const formData   = new FormData(formulario);
        if (!formulario || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para editar el cliente.", "alerta-roja");
            }
            return;
        }
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/clientes/editar', {
                method: 'POST',
                body: formData
            });
            const json      = await respuesta.json();
            const status    = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => { window.location.reload(); }, 1500);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
            }
            if (!resultado.hayErrores) {
                lanzarAlerta("Cliente editado correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});
